import { render, staticRenderFns } from "./V2DownloadWishlistModal.vue?vue&type=template&id=bae77384&scoped=true&"
import script from "./V2DownloadWishlistModal.vue?vue&type=script&lang=js&"
export * from "./V2DownloadWishlistModal.vue?vue&type=script&lang=js&"
import style0 from "./V2DownloadWishlistModal.vue?vue&type=style&index=0&id=bae77384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae77384",
  null
  
)

export default component.exports